import axios from 'axios';
import { Granule } from '../types/Granule';
import { formatToLocale, stringToUTC } from '../utils/dateUtils';
import { KAPTAIN_URL } from './config';

type GranulesTableFilter = 'ALL' | 'RELOADED' | 'NOT_RELOADED';
export const getGranules = async (kapsuleId: string, currentPage: number, pageSize: number, filter: GranulesTableFilter, searchText: string, orderColumn: string, orderNum: string, startTime: string, endTime: string): Promise<{
  data: Granule[],
  total: number
}> => {
  const response = await axios.get<{
    data: Granule[],
    total: number
  }>(`${KAPTAIN_URL}/api/kapsule/${kapsuleId}/read/internal`, {
    params: {
      currentPage,
      pageSize,
      filter,
      searchText,
      orderColumn,
      orderNum,
      startTime,
      endTime
    }
  });
  const granules = response.data.data.map((item) => {
    return {
      ...item,
      createdAt: formatToLocale(stringToUTC(item.createdAt), item.dateFormat ? item.dateFormat : 'yyyy-MM-dd'),
      updatedAt: formatToLocale(stringToUTC(item.updatedAt), item.dateFormat ? item.dateFormat : 'yyyy-MM-dd'),
    };
  });
  return {
    data: granules,
    total: response.data.total
  }
};

type GranulesStatus = {
  total: number,
  reloaded: number,
  unreloaded: number
}
export const getGranulesStatus = async (kapsuleId: string): Promise<GranulesStatus> => {
  const response = await axios.get<GranulesStatus>(`${KAPTAIN_URL}/api/kapsule/${kapsuleId}/read/internal/status`);
  return response.data;
};

export const deleteGranules = async (granuleIds: string[]): Promise<void> => {
  await axios.delete(`${KAPTAIN_URL}/api/kapsule/granules`, {
    data: { granuleIds },
  });
};
